export class Color {
  public static HIGHLIGHT_MUTATION: string = 'rgb(255,0,0)';
  public static DEFAULT_NODE_BORDER: string = 'rgb(0,0,0)';
  public static HIGHLIGHT_NEIGHBOUR: string = 'rgb(0,0,0)';
  public static HIGHLIGHT_NODE: string = 'rgb(127,0,255)';
  public static LOWLIGHT: string = 'rgb(206,204,204)';
}
